import '../common/bn-tabs';
import './parts/review-list';
import { css, html, LitEntity, SirenActionMixin } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import { sharedStyles } from '../styles/shared-styles';

class WorkOrderReviewIndex extends IndexMixin(SirenActionMixin(LitEntity)) {
  constructor() {
    super();
    this.workOrderHrefs = {};
    this.probationHrefs = {};
  }

  static get properties() {
    return {
      workOrderHrefs: { type: Object, attribute: false },
      probationHrefs: { type: Object, attribute: false },
      workOrdersHref: { type: String, attribute: false },
      probationsHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      bn-tabs {
        margin-bottom: 0;
      }
      review-list {
        padding-bottom: 1em;
      }
    `];
  }

  render() {
    const view = this.currentView || 'review';

    return html`
      <lit-entity href="${this.workOrdersHref}" @update="${this._onUpdateWorkOrders}"></lit-entity>
      <lit-entity href="${this.probationsHref}" @update="${this._onUpdateProbations}"></lit-entity>
      <h1>Review</h1>
      <bn-tabs>
        <bn-tab href="/review/review" ?active="${view === 'review'}">Needs Review</bn-tab>
        <bn-tab href="/review/rejected" ?active="${view === 'rejected'}">Rejected</bn-tab>
        <bn-tab href="/review/accepted" ?active="${view === 'accepted'}">Accepted</bn-tab>
      </bn-tabs>
      ${super.render()}
    `;
  }

  getViews() {
    return [
      {
        default: true,
        name: 'review',
        render: () => html`
          <review-list
            work-orders-href="${this.workOrderHrefs.needsReview || ''}"
            probations-href="${this.probationHrefs.needsReview || ''}"
          ></review-list>
        `,
      },
      {
        name: 'rejected',
        render: () => html`
          <review-list
            work-orders-href="${this.workOrderHrefs.rejected || ''}"
            probations-href="${this.probationHrefs.rejected || ''}"
          ></review-list>
        `,
      },
      {
        name: 'accepted',
        render: () => html`
          <review-list
            work-orders-href="${this.workOrderHrefs.accepted || ''}"
            probations-href="${this.probationHrefs.accepted || ''}"
          ></review-list>
        `,
      },
    ];
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.workOrdersHref = this.getHref('https://api.binsentry.com/rel/work-orders');
    this.probationsHref = this.getHref('https://api.binsentry.com/rel/probations');
  }

  _onUpdateWorkOrders(e) {
    const { entity } = e.detail;
    if (!entity) {
      return;
    }
    const action = entity.getAction('filter-work-orders');
    if (!action) {
      return;
    }

    const { url } = this.parseAction(action);
    url.searchParams.set('limit', 25);
    url.searchParams.set('type', '');
    url.searchParams.set('state', 'completed');
    this.workOrderHrefs.needsReview = url.href;
    url.searchParams.set('state', 'rejected');
    this.workOrderHrefs.rejected = url.href;
    url.searchParams.set('state', 'accepted');
    this.workOrderHrefs.accepted = url.href;
    this.requestUpdate();
  }

  _onUpdateProbations(e) {
    const { entity } = e.detail;
    if (!entity) {
      return;
    }
    const action = entity.getAction('filter-by-state');
    if (!action) {
      return;
    }
    const { url } = this.parseAction(action);
    url.searchParams.set('limit', 5);
    url.searchParams.set('state', 'waiting-review');
    this.probationHrefs.needsReview = url.href;
    url.searchParams.set('state', 'complete-rejected');
    this.probationHrefs.rejected = url.href;
    url.searchParams.set('state', 'complete-accepted');
    this.probationHrefs.accepted = url.href;
    this.requestUpdate();
  }
}

customElements.define('review-index', WorkOrderReviewIndex);
